import { render, staticRenderFns } from "./register-form2.vue?vue&type=template&id=c8087ada&scoped=true&"
import script from "./register-form2.vue?vue&type=script&lang=ts&"
export * from "./register-form2.vue?vue&type=script&lang=ts&"
import style0 from "./register-form2.vue?vue&type=style&index=0&id=c8087ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8087ada",
  null
  
)

export default component.exports